document.addEventListener('DOMContentLoaded', function () {
    let body = document.querySelector('body');
    let burger = document.querySelector('.burger-menu');
    let overlay = document.querySelector('.menu-overlay');
    let closeBtn = document.querySelector('.close-menu');

    if(burger){
        burger.addEventListener('click', function () {
            overlay.classList.add('active');
            body.classList.add('overflow-none');
        });
    }

    if(closeBtn){
        closeBtn.addEventListener('click', function () {
            overlay.classList.remove('active');
            body.classList.remove('overflow-none');
        });
    }
});
